import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {centeredFlex, fontSize} from '../mixins';


const StyledWrapper = styled.div`
  ${centeredFlex};
`

const StyledNotFound = styled.div`
    width: 340px;
    margin: 80px auto 0;
    text-align: center;

  @media screen and (min-width: 768px) {
    width: 80%;
    margin: 200px auto 0;
  }
  
  img {
      width: 374px;
      height: 152px;
      margin-bottom: 36px;

     @media screen and (max-width: 768px) {
       width: 80%;
     }
  }
  
  p {
    text-align: center;
    ${fontSize(18)};
    line-height: 28px;
    color: #323232;

    > span {
      color: #07c0b1;
    }
  }
`


const NotFound = (props) => {
    const { t, } = useTranslation('translation', { useSuspense: false });

    return (
        <StyledWrapper>
            <StyledNotFound>
                <img src="./images/404-img.svg" alt={'404 Page not found'}/>
                <p>{t('error_page_info_text')}</p>
            </StyledNotFound>
        </StyledWrapper>
    );
};

export default NotFound;